// @ts-nocheck
import type * as Types from '../../../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateOrderMutationVariables = Types.Exact<{
  input: Types.CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'CreateOrderResult', id: string, clientSecret?: string | null } };

export type CreateOrderChariotMutationVariables = Types.Exact<{
  input: Types.CreateOrderChariotInput;
}>;


export type CreateOrderChariotMutation = { __typename?: 'Mutation', createOrderChariot: { __typename?: 'CreateOrderChariotResult', id?: string | null, success: boolean, error: Types.ChariotError } };


export const CreateOrderDocument = /*#__PURE__*/ gql`
    mutation CreateOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    id
    clientSecret
  }
}
    `;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export const CreateOrderChariotDocument = /*#__PURE__*/ gql`
    mutation CreateOrderChariot($input: CreateOrderChariotInput!) {
  createOrderChariot(input: $input) {
    id
    success
    error
  }
}
    `;

/**
 * __useCreateOrderChariotMutation__
 *
 * To run a mutation, you first call `useCreateOrderChariotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderChariotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderChariotMutation, { data, loading, error }] = useCreateOrderChariotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderChariotMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderChariotMutation, CreateOrderChariotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderChariotMutation, CreateOrderChariotMutationVariables>(CreateOrderChariotDocument, options);
      }
export type CreateOrderChariotMutationHookResult = ReturnType<typeof useCreateOrderChariotMutation>;